module.exports = __webpack_public_path__ + "static/media/forurensning.09b7ff39.m4a";